import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  selector: 'lum-ui-virtual-numpad',
  templateUrl: './ui-virtual-numpad.component.html',
  styleUrls: ['./ui-virtual-numpad.component.scss'],
})
export class UiVirtualNumpadComponent implements OnInit {
  form :UntypedFormGroup;

  virtualNumbers :string[] = [
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '0',
    '.',
  ];

  constructor(
    private fb :UntypedFormBuilder,
    private dialogRef :MatDialogRef<UiVirtualNumpadComponent>,
  ) {}

  ngOnInit() :void {
    this.initForm();
  }

  onAppendToInput(value :string) :void {
    const quantity = this.quantityControl;
    const currentValue = quantity?.value;

    if (value === '.') {
      if (currentValue && currentValue?.includes('.')) {
        return;
      }
      if (currentValue === 0) {
        quantity?.setValue('0.');

        return;
      }

      quantity?.setValue(`${currentValue}.`);

      return;
    }

    const newValue = currentValue === 0 ? value : `${currentValue}${value}`;
    quantity?.setValue(newValue);
  }

  onBackspaceClick() :void {
    const quantity = this.quantityControl;
    const currentValue = quantity?.value;

    if (currentValue === 0) {
      return;
    }

    const newValue = currentValue?.slice(0, -1);
    quantity?.setValue(newValue);

    if (newValue === '') {
      quantity?.setValue(0);
    }
  }

  onClearClick() :void {
    this.quantityControl?.setValue(0);
  }

  onDone() :void {
    this.dialogRef.close(Number(this.quantityControl?.value));
  }

  private initForm() :void {
    this.form = this.fb.group({
      quantity: [{ value: 0, disabled: true }, [Validators.required]],
    });
  }

  get quantityControl() :UntypedFormControl {
    return this.form.get('quantity') as UntypedFormControl;
  }
}
